import { newsImage,newsLogo,newImg1,newImg2,newImg3 } from '../../images/news/index'
let newsList = [
  {
    id: 4,
    title: 'J-DIRECT J-DIRECT BOX公式プロモーション動画公開！',
    msg1: '海外で日本のIPを取得できるVPNルーター内蔵の新世代機種【J-DIRECT BOX】海外で日本の動画・テレビが観られる日本VPNルーター内蔵のテレビBOXがついに登場！',
    msg2: 'コロナ巣ごもり生活のあなたに、とっておきの朗報！日本のエンターテインメントが気軽に楽しめるとあって、現在好評販売中！まだ知らないそこのあなた、今すぐプロモーション動画をCheck！',
    date: '2021年1月28日',
    newsImage: newImg3
  },
  {
    id: 3,
    title: 'J-DIRECT BOX（ジェイ・ダイレクト・ボックス）海外で日本のIPを取得できるVPNルーター内蔵SmartTV BOX',
    msg1: '「日本IPアドレス制限」された日本の動画・テレビコンテンツを海外で簡単・便利に視聴できる！',
    msg2: '日本VPNルーター内蔵「SmartTV BOX」が発売開始！',
    date: '2020年11月01日',
    newsImage: newImg1
  },
  {
    id:2,
    title: 'J-DIRECT BOX及びJ-DIRECT日本VPNプロバイダー接続サービス海外及び日本販売代理店募集開始のお知らせ',
    msg1: 'J-DIRECT BOXの販売スタートに併せて、販売元のDirect Provider Co., Ltd.（以下弊社）',
    msg2: 'では北米、欧州、豪州、中東地域で自社ルートをお持ちの、海外在住日本人に長期的なサービスを提供されている各業界を対象として、代理店の募集を開始いたしました。',
    date: '2020年11月01日',
    newsImage: newImg2 
  }
]
// newsList.forEach(n => {
//   n['newsImage'] = newsLogo[11]
//   console.log(newsLogo[1])
// })
export default newsList


// WEBPACK FOOTER //
// ./src/data-js/news/index.js